import {
  Card,
  Container,
  Input,
  FormButton,
  Text,
  Checkbox,
  Box,
} from "../components/UI";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useUserData } from "../hooks/useUserData";
import { useNavigate, useSearchParams } from "react-router-dom";

export const RegisterStep1 = () => {
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const [emailValue, setEmailValue] = useState('');
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset
  } = useForm({
    mode: "onChange",
    defaultValues: {
      email: searchParams.get("email")?.replace("'", "").replace("'", ""),
    },
  });

  const { setEmail, lang } = useUserData();
  const onSubmit = (data) => {
    setEmail(data.email);
    navigate("/Register/Step2?email=" + data.email);
  };
   useEffect(()=>{
        reset();
        setEmailValue(searchParams.get("email")?.replace("'", "").replace("'", ""))
   },[])

  return (
    <Box display="columnCenter">
      <Container>
        <Card>
          <Text>{lang?.step1of3}</Text>
          <Text role="h1">{lang?.enterYourEmailAddress}</Text>
          <Text role="h3">{lang?.youWillUseThisEmail}</Text>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Controller
              name="email"
              control={control}
              rules={{
                required: true,
                pattern: {
                  value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                  message: lang?.invalidEmail,
                },
              }}
              render={({ field }) => (
                <Input
                  props={{
                    ...field
                  }}
                  value={emailValue}
                  placeholder="E-mail"
                />
              )}
            />
            {errors.email && errors.email.type === "required" && (
              <Text role="validationMessage">{lang?.emailRequired}.</Text>
            )}
            {errors.email && errors.email.type !== "required" && (
              <Text role="validationMessage">{errors.email.message}</Text>
            )}
            <FormButton role="secondary" title="Log In">
              {lang?.agreeAndContinue}
            </FormButton>
          </form>
          <Text>
            {lang?.doYouHaveAlreadyAnAccount}{" "}
            <Link to={`/`}>{lang?.loginNow}.</Link>{" "}
          </Text>
        </Card>
      </Container>
    </Box>
  );
};
